import {
  axi,
  getBackendAssetPath,
  GetListOutput,
  GetListParams,
} from '@shared/api';
import {validateData} from '@shared/utils';
import {MarketplaceItem, MarketplaceItemType} from '../types';
import {v8nSchemaOfGetMarketplaceItemsResponse} from './backendSchemas';
import {GetMarketplaceItemsResponse} from './backendTypes';
import {mapMarketplaceItemFromBackend} from './dataMappers';

export interface GetMarketplaceItemsParams extends GetListParams {
  type?: MarketplaceItemType;
}

export const getMarketplaceItems = async ({
  page,
  pageSize,
  type,
}: GetMarketplaceItemsParams = {}): Promise<GetListOutput<MarketplaceItem>> => {
  const response = await axi.get<GetMarketplaceItemsResponse>(
    '/admin/rewards/marketplace/items',
    {
      params: {
        type,
        page,
        per_page: pageSize,
      },
    },
  );

  validateData(
    response.data,
    v8nSchemaOfGetMarketplaceItemsResponse,
    'getMarketplaceItems',
  );

  const {
    total,
    total_pages,
    array,
    page: pageFromBackend,
    per_page: pageSizeFromBackend,
  } = response.data;

  return {
    page: pageFromBackend,
    pageSize: pageSizeFromBackend,
    total,
    totalPages: total_pages,
    items: (array ?? []).map(item => mapMarketplaceItemFromBackend(item)),
  };
};

export interface CreateMarketplaceItemParams {
  title: string;
  description: string;
  count: number;
  type: MarketplaceItemType;
  price: number;
  imageUrl: string;
  order: number;
  isExclusive: boolean;
}

export const createMarketplaceItem = ({
  title,
  description,
  count,
  type,
  price,
  imageUrl,
  order,
  isExclusive,
}: CreateMarketplaceItemParams): Promise<void> => {
  const isFreeItem = price === 0;

  return axi.post('/admin/rewards/marketplace/items', {
    title,
    description,
    type,
    ...(isFreeItem ? {} : {count, price}),
    image_url: getBackendAssetPath(imageUrl),
    order,
    is_exclusive: isExclusive,
  });
};
